package org.chiangmeng.qfast.core.data.di

import org.chiangmeng.qfast.core.data.DriverFactory
import org.chiangmeng.qfast.database.QFastDatabase
import org.koin.dsl.module
import org.koin.core.module.Module
import org.chiangmeng.qfast.core.domain.ports.TextToSpeechService
import org.chiangmeng.qfast.core.data.speech.JsTextToSpeechService

actual val localDataModule: Module = module {
    single { DriverFactory().createDriver() }
    single { QFastDatabase(get()) }
    single { get<QFastDatabase>().queueHistoryQueries }
    single<TextToSpeechService> { JsTextToSpeechService() }
}
